import api from './api';

/**
 * @returns {Promise<{
 *  test_id: string
 *  test_name: string
 *  skill_id: string
 * }[]>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tests-getAllTests
 */
export default async function getTestComponents(level_id) {
    const { data } = await api.get(`levels/${level_id}/tests`);

    return data;
}